import React from "react";
import { browserHistory } from "react-router";
import { useSelector } from "react-redux";
import { readAppData } from "modules/shared/redux-store/dataReaders";
import Moment from "moment";
import { FSMoneyFactory } from "../../shared/helpers/money/moneyFactory";
import { MoneyFormatter } from "../../shared/helpers/money/moneyFormatter";
import DigitalizedOrderCard from "../../shared/components/digitalized-orders/DigitalizedOrderCard";

export const DigitalizedOrdersOverviewPage = (props) => {
  const orderGroups = useSelector(s => readAppData(s, "digitalizedOrders"));

  const handleOrderClicked = id => {
    browserHistory.push(`/startups/digitalized_orders/${id}`);
  };

  return (
    <div className="digitalized-orders">
      <h4>Gemeldetete Aufträge</h4>
      <h1>Übersicht</h1>
      <div className="divider" />
      <div className="digitalized-orders__container">
        {!orderGroups || orderGroups.length === 0 ? (
          <p>Du hast noch keine Aufträge angelegt</p>
        ) : (
          orderGroups.map((orderGroup, index) => (
            <DigitalizedOrderCard
              key={index}
              onClick={() => handleOrderClicked(orderGroup.id)}
              onKeyPress={() => handleOrderClicked(orderGroup.id)}
              shippingAddress={orderGroup.orders[0].shippingAddress}
              orderDate={Moment(orderGroup.orderChannelable.orderDate).format(
                "DD.MM.YYYY",
              )}
              creationDate={Moment(orderGroup.createdAt).format("DD.MM.YYYY")}
              netPrice={MoneyFormatter.fromBigCents(
                FSMoneyFactory.toMoney(orderGroup.orders[0].netSumCents),
              )}
              grossPrice={MoneyFormatter.fromBigCents(
                FSMoneyFactory.toMoney(orderGroup.orders[0].grossSumCents),
              )}
            />
          ))
        )}
      </div>
      <div className="digitalized-orders__all">
        {props.params.scope !== 'all' && (
          <a href={`${props.location.pathname}/all`}>
            Alle anzeigen
          </a>
        )}
      </div>
    </div>
  );
};
